import { useContext } from "react";
import { GridColumn as Column } from "@progress/kendo-react-grid/dist/npm/GridColumn";
import { GridCell } from "@progress/kendo-react-grid/dist/npm/cells/GridCell";
import { CrossingCountriesComboBoxCell } from "./CrossingCountriesComboBoxCell";
import { EditProjectContext } from "../../../../EditProjectContext";
import { isProjectReadOnly } from "../../../../IsProjectReadOnly";
import { ReadOnlyProps } from "../../../../ReadOnlyProps";

export const CrossingCountryGridColumns = ({ isReadOnly }: ReadOnlyProps) => {
  const { project } = useContext(EditProjectContext);
  const isEditable = !isProjectReadOnly(project) && !isReadOnly;

  return [
    <Column
      key="Name"
      field="Name"
      title="Name"
      filter="text"
      editable={isEditable}
      editor="text"
      cell={isEditable ? CrossingCountriesComboBoxCell : GridCell}
      resizable
    />,
    <Column
      width="100px"
      key="InboundMautKM"
      field="InboundMautKM"
      title="Inbound Maut KM"
      filter="numeric"
      editor="numeric"
      editable={isEditable}
      resizable
    />,
    <Column
      width="100px"
      key="ReturnMautKM"
      field="ReturnMautKM"
      title="Return Maut KM"
      filter="numeric"
      editor="numeric"
      editable={isEditable}
      resizable
    />,
  ];
};
